import createUploadUrl from "./createUploadUrl";
import type { Request, UploadResponse } from "./types";

const METHOD_PUT = "PUT";
const HEADER_CONTENT_TYPE = "Content-Type";

const QUERY_SEPARATOR = "?";
const HOST_SEPARATOR = ".com/";

const upload = async (
  request: Request,
  isPublic: boolean,
  contentType: string,
  body: BodyInit,
): Promise<UploadResponse> => {
  const uploadUrl = await createUploadUrl(request, isPublic, contentType);

  const headers = { [HEADER_CONTENT_TYPE]: contentType };
  const options = { method: METHOD_PUT, body, headers };

  await fetch(uploadUrl, options);

  const [ url ] = uploadUrl.split(QUERY_SEPARATOR);
  const [ , pathWithQuery ] = uploadUrl.split(HOST_SEPARATOR);
  const [ path ] = pathWithQuery.split(QUERY_SEPARATOR);

  const response = {
    url,
    path,
    isPublic,
  };

  return response;
};

export default upload;
